exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 820px) {\n  .Header-ButtonsWrapper {\n    padding: 0 5vw; } }\n\n@media (max-width: 550px) {\n  .LogoButton_name_AlexanderIvankovLogo {\n    display: none; }\n  .Article-Content {\n    padding: 10px 20px; } }\n", ""]);

// exports
